import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import './Header.css';
import WorkcrtlLogo from '../assets/images/Workctrl-logo.png';

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isProductPage = location.pathname === '/product-ecosystem';
  const isStakeholderPage = location.pathname === '/stakeholder';
  const isSubPage = isProductPage || isStakeholderPage;

  const handleScrollClick = (sectionId) => (e) => {
    e.preventDefault();
    setMobileOpen(false);
    if (isSubPage) {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="site-header">
      <div className="header-inner container">
        <div className="logo">
          <Link to="/">
            <img
              src={WorkcrtlLogo}
              alt="WorkCtrl"
              className="logo-img"
            />
          </Link>
        </div>

        <button className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        <nav className={`main-nav ${mobileOpen ? 'open' : ''}`}>
          <ul className="nav-menu">
            <li><a href="#our-mission" onClick={handleScrollClick('our-mission')}>Our Mission</a></li>
            <li><a href="#who-we-are" onClick={handleScrollClick('who-we-are')}>Who We Are</a></li>
            {isSubPage ? (
              <li><Link to="/" onClick={() => { setMobileOpen(false); window.scrollTo(0, 0); }}>Home</Link></li>
            ) : (
              <li><Link to="/product-ecosystem" onClick={() => { setMobileOpen(false); window.scrollTo(0, 0); }}>Product</Link></li>
            )}
            <li><Link to="/stakeholder" onClick={() => { setMobileOpen(false); window.scrollTo(0, 0); }} className={isStakeholderPage ? 'active' : ''}>Stakeholder</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
